<template>
    <div style="text-align:left">
        <Breadcrumb style="margin: 0px 10px 20px">
            <BreadcrumbItem to="/crowdAdmin">人群管理</BreadcrumbItem>
            <BreadcrumbItem>{{crowd_name}}</BreadcrumbItem>
        </Breadcrumb>
        <Card>
            <Form ref="form" :model="formItem" :label-width="100">
                <Row>
                    <Col span="6">
                    <FormItem label="APP用户id">
                        <Input v-model="formItem.app_user_id"></Input>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <Button @click="handleSearch" style="margin-left:30px"
                        type="primary">搜索</Button>
                    </Col>
                </Row>
            </Form>
            <Button @click="handleCreate()" style="margin:0px 10px 20px" type="primary">新增</Button>
            <Table :columns="columns" :data="data"></Table>
            <Page show-total :current="page" @on-change="changePage" style="margin-top: 10px; text-align: right"
                :total="total_count" :page-size="20" />
            <Modal v-model="modal1" title="新增测试用户" width='300' @on-ok="ok" @on-cancel="cancel">
                <Form ref="formInline" :model="formInline" :rules="ruleInline" inline>
                    <FormItem label="APP用户Id" prop="app_user_id" style="width: 100%">
                        <Input v-model="formInline.app_user_id"></Input>
                    </FormItem>
                    <FormItem label="备注" style="width: 100%">
                        <Input v-model="formInline.description"></Input>
                    </FormItem>
                </Form>
            </Modal>
        </Card>
    </div>
</template>
<script>
import { recipientList, createRecipient, deleteRecipient, updateRecipientDesciption } from "@/request/api"
import Cookies from 'js-cookie';
export default {
    name: 'recipientAdmin',
    meta: {},
    data() {
        return {
            formItem: {
                app_user_id: ''
            },
            columns: [
                {
                    title: "APP用户id",
                    key: "app_user_id",
                    align: "center"
                },
                {
                    title: "备注",
                    key: "description",
                    align: "center"
                },
                {
                    title: "创建时间",
                    key: "created_at",
                    align: "center"
                },
                {
                    title: "创建者",
                    key: "user_name",
                    align: "center"
                },
                {
                    title: "操作",
                    key: "action",
                    align: "center",
                    width: '200',
                    render: (h, params) => {
                        return h("div", [
                            h("Button", {
                                props: {
                                    type: "text",
                                    size: "small",
                                },
                                on: {
                                    click: () => {
                                        this.editRecipient(params.index)
                                    },
                                },
                            }, "修改备注"),
                            h("Button", {
                                props: {
                                    type: "text",
                                    size: "small",
                                },
                                on: {
                                    click: () => {
                                        this.$Modal.confirm({
                                            title: "提示",
                                            content: "是否删除该项？",
                                            onOk: () => {
                                                this.remove(params.index)
                                            },
                                        });
                                    },
                                },
                            }, "删除"),
                        ]);
                    },
                },
            ],
            data: [],
            total_count: 0,
            page: 1,
            formInline: {
                app_user_id: '',
                description: ''
            },
            ruleInline: {
                app_user_id: [
                    { required: true, message: '不能为空，数字类型', trigger: 'blur', pattern: /^[0-9]+$/ }
                ]
            },
            modal1: false,
            description: ''
        };
    },
    methods: {
        getData(page = 1, page_size = 20, crowd_id, app_user_id) {
            recipientList({ page, page_size, crowd_id, app_user_id }).then(res => {
                if (res.data.code == 200) {
                    this.data = res.data.data.crowd_recipients
                    this.total_count = res.data.data.total
                    this.page = page
                }
            })
        },
        handleSearch(){
            const numberRegex = /^[0-9]+$/;
            const isNumberValid = numberRegex.test(this.formItem.app_user_id);
            if(this.formItem.app_user_id != '' && !isNumberValid){
                this.$Message.error('请输入数字类型');
                return false;
            }
            this.getData(1, 20, this.crowd_id, this.formItem.app_user_id);
        },
        changePage(page) {
            this.getData(page, 20, this.crowd_id, this.formItem.app_user_id);
        },
        handleCreate() {
            this.modal1 = true
        },
        ok() {
            this.$refs['formInline'].validate((valid) => {
                if (valid) {
                    createRecipient(
                        {
                            crowd_id: this.crowd_id,
                            app_user_id: this.formInline.app_user_id,
                            description: this.formInline.description
                        }
                    ).then(({ data: res }) => {
                        if (res.code == 200) {
                            this.getData(this.page, 20, this.crowd_id, this.formItem.app_user_id)
                        }
                        this.$Message.info(res.msg);
                        this.formInline = {
                            app_user_id: '',
                            description: ''
                        }
                    })
                } else {
                    this.$Message.error('Fail!');
                }
            })
        },
        cancel() {
            this.modal1 = false,
            this.formInline = {
                app_user_id: '',
                description: ''
            }
        },
        editRecipient(index) {
            this.description = this.data[index].description
            this.$Modal.confirm({
                new_email: '',
                new_password: '',
                closable: true,
                title: '备注',
                width: 300,
                render: (h) => {
                    return h('Input', {
                        props: {
                            value: this.description,
                        },
                        on : {
                            input: (value) => {
                                this.description = value;
                            }
                        }
                    }
                    );
                },
                onOk: () => {
                    updateRecipientDesciption(
                        {
                            crowd_recipient_id: this.data[index].crowd_recipient_id,
                            description: this.description
                        }
                    ).then(({ data: res }) => {
                        if (res.code == 200) {
                            this.getData(this.page, 20, this.crowd_id, this.formItem.app_user_id)
                        }
                        this.$Message.info(res.msg);
                    })
                },
                onCancel: () => {
                }
            })
        },
        remove(index) {
            deleteRecipient(
                {
                    crowd_recipient_id: this.data[index].crowd_recipient_id
                }
            ).then(({ data: res }) => {
                if (res.code === 200) {
                    this.getData(this.page, 20, this.crowd_id, this.formItem.app_user_id)
                }
                this.$Message.info(res.msg);
            })
        },
    },
    created() {
        Cookies.set('active_name', '7');
        this.crowd_id = this.$route.query.crowd_id
        this.crowd_name = this.$route.query.crowd_name
        this.getData(1, 20, this.crowd_id, this.formItem.app_user_id)
    },
};
</script>


// WEBPACK FOOTER //
// src/views/Crwod/CrowdRecipient.vue